"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = exports.shuffle = void 0;
var random_1 = require("./random");
/**
 * Shuffles an array in-place using a seed
 * @param array input array
 * @param seed array of four numbers to use as the seed
 * @returns the shuffled array
 */
function shuffle(array, seed) {
    var currentIndex = array.length;
    var getRandom = random_1.sfc32.apply(void 0, seed);
    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
        // Pick a remaining element...
        var randomIndex = Math.floor(getRandom() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        var temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}
exports.shuffle = shuffle;
function sum(array) {
    var sum = 0;
    for (var index = 0; index < array.length; index++) {
        sum += array[index];
    }
    return sum;
}
exports.sum = sum;
//# sourceMappingURL=array.js.map